import comp from "./BluePrintSync";
export default comp;
